import { Directive, Injector, Optional, SkipSelf } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, setHeaderConfigForTable } from "@wm/components-base";
import { TableComponent } from '../table.component';

const DEFAULT_CLS = '';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-table-column-group',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTableColumnGroup]',
  providers: [
    provideAsWidgetRef(TableColumnGroupDirective)
  ],
  standalone: true,
  exportAs: 'wmTableColumnGroup'
})
export class TableColumnGroupDirective extends StylableComponent {
  static initializeProps = register('wm-table-column-group');
  public name: any;
  accessroles: any;
  caption: any;
  colClass: any;
  textalignment: any;
  config: any = {};

  constructor(inj: Injector, @Optional() viewParent: Parent, @SkipSelf() @Optional() public group: TableColumnGroupDirective, @Optional() public table: TableComponent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  populateConfig() {
    this.config = {
      field: this.name,
      displayName: this.getAttr('caption.bind')?'bind:'+this.getAttr('caption.bind'): ( this.getAttr('caption') || this.caption || ''),
      columns: [],
      isGroup: true,
      accessroles: this.accessroles,
      textAlignment: this.getAttr('textalignment') || 'center',
      backgroundColor: this.backgroundcolor,
      class: this.getAttr('col-class')
    };
  }

  override onPropertyChange(key: any, nv: any, ov?: any) {
    if (key === 'caption') {
      this.config.displayName = nv || '';
      this.table.callDataGridMethod('setColumnProp', this.config.field, 'displayName', nv, true);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    this.populateConfig();
    // when group is inside another group (i.e. sub-level column-group) then consider the col index and not header index.
    const headerIndex = parseInt((this.getAttr('headerindex') as string), 10);
    const colIndex = parseInt((this.getAttr('index') as string), 10);
    const fieldName = this.group && this.group.name;
    setHeaderConfigForTable(this.table.headerConfig, this.config, fieldName, fieldName ? colIndex : headerIndex);
  }
}

